import Vue from 'vue';
import metatagService from '@/api/metatag-service';
import eventBus, { OPEN_SNACKBAR } from '@/util/event-bus';
import i18n from '@/i18n/i18n-config';
import { mapErrorsToInputs } from '@/util/forms';

const state = {
  metatags: {},
  metatagValidationErrors: {},
  savingMetatags: false,
};

const getters = {};

const mutations = {
  SET_METATAGS(state, { data }) {
    [state.metatags] = data;
  },

  UPDATE_METATAG(state, metatag) {
    state.metatags = metatag;
  },

  SET_METATAG_VALIDATION_ERRORS(state, metatagValidationErrors) {
    state.metatagValidationErrors = metatagValidationErrors;
  },

  CLEAR_METATAG_VALIDATION_ERRORS(state, field) {
    Vue.delete(state.metatagValidationErrors, field);
  },

  SET_SAVING_METATAG(state, loading) {
    state.loadingMetatags = loading;
  },
};

const actions = {
  fetchMetatags({ commit }) {
    if (state.metatags.keywords) {
      return Promise.resolve(state.metatags.keywords);
    }
    return metatagService.getMetaTags().then((res) => {
      commit('SET_METATAGS', res);
      return res;
    });
  },

  updateMetatag({ commit }, metatag) {
    commit('SET_SAVING_METATAG', true);
    return metatagService
      .create(metatag)
      .then((res) => {
        commit('UPDATE_METATAG', res.data);
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('metatag_updated'));
        return res.data;
      })
      .catch((err) => {
        commit('SET_METATAG_VALIDATION_ERRORS', mapErrorsToInputs(err));
        throw err;
      })
      .finally(() => commit('SET_SAVING_METATAG', false));
  },

  clearMetatagValidationErrors({ commit }, field) {
    commit('CLEAR_METATAG_VALIDATION_ERRORS', field);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
